/**
 * User Portal BFF
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { DateTimePeriod } from './date-time-period';


export interface ExportSwapRequestRequest { 
    accountId?: string | null;
    statusIds?: Array<number> | null;
    datePeriod?: DateTimePeriod;
}

